import React from "react";
import SearchBar from "./SearchBar";

const FiltersBar = ({
  canProceed,
  showFiltersModal,
  setShowFiltersModal,
  showMobileSearch,
  setShowMobileSearch,
  isFilterModalVisible,
  searchProps,
  searchresultsCount, hasAccessUntil, isMember, hasAccess
}) => {
  // const [showFiltersModal, setShowFiltersModal] = useState(false);
  const showFiltersList = () => {
    if (canProceed()) {
      setShowFiltersModal(!showFiltersModal);
      // if (this.showFeedFilterModal) {
      //   this.applyFilters();
      // }
    }
  };

  const toggleShowMobileSearch = () => {
    setShowMobileSearch(!showMobileSearch);
  };

  return (
    <div className="py-2 px-2 flex justify-end items-center filter-font">
      <div
        className="mr-2"
        style={{ maxWidth: "120px", width: "120px", minWidth: "120px" }}
      >
        <div
          onClick={() => showFiltersList()}
          style={{
            paddingTop: ".8rem",
            paddingBottom: ".9rem",
            marginTop: ".24rem"
          }}
          className="cursor-pointer px-4 text-sm mr-2 text-blue-800 text-center border rounded border-blue-800 hover:bg-blue-800 hover:text-white"
        >
          <span>FILTERS</span>
          {isFilterModalVisible ? (
            <i className="fas fa-chevron-right align-middle ml-1"></i>
          ) : (
            <i className="fas fa-chevron-down align-middle ml-1"></i>
          )}
        </div>
      </div>

      <div className="w-full hidden md:flex items-center">
        {/* <search-bar /> */}
        <SearchBar
          canProceed={canProceed}
          searchProps={searchProps}
          searchresultsCount={searchresultsCount}
          hasAccessUntil={hasAccessUntil}
          isMember={isMember}
          hasAccess={hasAccess}
        ></SearchBar>
      </div>
      <div className="md:hidden flex items-center">
        <div>
          <i
            onClick={() => toggleShowMobileSearch()}
            className="fas fa-search search-icon cursor-pointer"
          ></i>
        </div>
      </div>
    </div>
  );
};

export default FiltersBar;
